// extracted by mini-css-extract-plugin
module.exports = {"header":"frontend-components-trial-common-styles-Header__header--1D7n8","logo":"frontend-components-trial-common-styles-Header__logo--1uQ76"};